// extracted by mini-css-extract-plugin
export default {"payment":"Yq","title_row":"Zq","border_bottom":"ar","promo_wrapper":"br","payment_wrapper":"cr","label":"er","card_row":"fr","cardcontain":"gr","card_input":"hr","card_error":"ir","card_label":"jr","lock":"kr","same_address":"lr","place_order_button":"mr","buttonwrap":"nr","hide_form":"or","paypal_buttons":"pr","review_button":"qr","alt_payment":"rr"};
    if(module.hot) {
      // 1715276855654
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  